type EditListItemProps = {
    listItemName: string;
    setListItemName: (v: string) => void;
    listItemActive: boolean;
    setListItemActive: (v: boolean) => void;
    error: string | null;
    onBack: () => void;
    onSave: () => void;
};

export const EditListItem: React.FC<EditListItemProps> = ({
    listItemName,
    setListItemName,
    listItemActive,
    setListItemActive,
    error,
    onBack,
    onSave,
}) => {
    return (
        <div className="inv-modal-overlay2">
            <div className="inv-modal2" role="dialog" aria-modal="true">
                <div className="nec-stack">
                    <div className="nec-block">
                        <div className="nec-header">Položka číselníku</div>
                        <div className="nec-control">
                            <input
                                className="nec-input"
                                value={listItemName}
                                onChange={(e) => setListItemName(e.target.value)}
                                placeholder="Název..."
                            />
                        </div>
                    </div>

                    <div className="nec-block">
                        <div className="nec-header">Aktivní</div>
                        <div className="nec-control-left">
                            <input
                                type="checkbox"
                                checked={listItemActive}
                                onChange={(e) => setListItemActive(e.target.checked)}
                            />
                        </div>
                    </div>

                    <div className="item-list-toolbar-right">
                        <button type="button" className="item-list-tab is-active" onClick={onBack}>
                            Zpět
                        </button>
                        <button type="button" className="item-list-tab is-active" onClick={onSave}>
                            Uložit
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};